import { trpc } from '@/shared/api/trpc';

const useInvalidateOrg = () => {
  const utils = trpc.useUtils();
  return (id: string) => {
    utils.organizations.findOne.invalidate({ id });
    utils.auth.me.invalidate();
  };
};

/**
 * Generate a new MCP planner key. The raw key is in the mutation result and
 * must be shown to the operator immediately — it is never retrievable again.
 *
 * Regenerating REPLACES the organisation's key, so every consultant already
 * connected stops working at their next call until they are given the new one.
 * The card says so before the button is pressed.
 */
export const useGenerateMcpPlannerKey = () => {
  const invalidate = useInvalidateOrg();
  return trpc.organizations.generateMcpPlannerKey.useMutation({
    onSettled: (_data, _err, vars) => {
      if (vars?.id) invalidate(vars.id);
    },
  });
};

/** Revoke the key. This is the kill switch for the whole planner surface. */
export const useRevokeMcpPlannerKey = () => {
  const invalidate = useInvalidateOrg();
  return trpc.organizations.revokeMcpPlannerKey.useMutation({
    onSettled: (_data, _err, vars) => {
      if (vars?.id) invalidate(vars.id);
    },
  });
};
